import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-dusk"]
const _hoisted_2 = { class: "flex flex-col sm:flex-row gap-4 items-center relative" }
const _hoisted_3 = { class: "w-28 h-28 p-2 rounded border flex items-center justify-center" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "flex-1 w-full" }
const _hoisted_6 = {
  class: "text-lg font-semibold",
  "data-dusk": "cart-item-title"
}
const _hoisted_7 = { class: "border-t border-gray-200 mt-6" }
const _hoisted_8 = {
  key: 0,
  class: "absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10",
  "data-dusk": "removing-overlay"
}

import { ref, watch } from 'vue';
import PageLoading from '@/lib/components/Loading/PageLoading.vue';
import type { OrderItem } from '@/models/webshop.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseOrderCard',
  props: {
    item: {},
    category: {},
    editable: { type: Boolean },
    isLoading: { type: Boolean },
    dataDusk: {}
  },
  emits: ['remove-item', 'update-item', 'select-item'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const isLoadingLocal = ref(false);

watch(() => props.isLoading, (newVal) => {
  if (newVal === true || newVal === false) {
    isLoadingLocal.value = newVal;
  }
});

const handleRemoveItem = (event: OrderItem) => {
  isLoadingLocal.value = true;
  emit('remove-item', event);
};

const resetRemovingState = () => {
  isLoadingLocal.value = false;
};

__expose({
  handleRemoveItem,
  resetRemovingState,
  isLoadingLocal
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative bg-white border border-gray-200 rounded-lg shadow-sm p-6 flex flex-col",
    "data-dusk": _ctx.dataDusk || 'order-item'
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.item.productOptions?.image?.url || 'https://placehold.co/350x180/EEEEEE/AAAAAA?text=No+image',
          alt: _ctx.item.productName,
          class: "max-w-full max-h-full object-contain"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.item.productName), 1),
        _renderSlot(_ctx.$slots, "display-options")
      ]),
      (_ctx.editable && !isLoadingLocal.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "#",
            class: "absolute top-0 right-0 text-xs text-primary-500 font-medium no-underline hover:underline whitespace-nowrap z-20 p-2",
            "data-dusk": "remove-item-button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleRemoveItem(_ctx.item)), ["prevent"]))
          }, _toDisplayString(_ctx.$t('platform.webshop.button.remove')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (isLoadingLocal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(PageLoading)
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})